import {
  Button,
  ButtonGroup,
  closeCurrentDialog,
  DataStatus,
  showNotification,
} from 'platform/components';
import {Text, VStack} from 'platform/foundation';

import {useDeactivateBranchMutation, useGetBranchQuery} from '@dms/api/core';
import i18n from '@dms/i18n';
import {handleApiError} from '@dms/shared';

type DeactivateBranchDialogContentProps = {
  branchId: string;
  onSuccess?: () => void;
};

export function DeactivateBranchDialogContent(props: DeactivateBranchDialogContentProps) {
  const [deactivateBranch, {isLoading}] = useDeactivateBranchMutation();
  const {data: branchInfo, isLoading: isGetBranchQueryLoading} = useGetBranchQuery({
    branchId: props.branchId,
  });

  const handleDeactivateBranch = () => {
    deactivateBranch({branchid: props.branchId})
      .unwrap()
      .then(() => {
        showNotification.success(i18n.t('general.notifications.success'));
        closeCurrentDialog();
        props.onSuccess?.();
      })
      .catch(handleApiError);
  };

  return (
    <DataStatus isLoading={isGetBranchQueryLoading}>
      <VStack spacing={1}>
        <Text>{i18n.t('entity.deactivateBranchDialog.description', {name: branchInfo?.name})}</Text>
      </VStack>
      <ButtonGroup align="right">
        <Button
          data-testid="deleteBranchDialogConfirm"
          variant="primary"
          onClick={handleDeactivateBranch}
          isLoading={isLoading}
          title={i18n.t('general.actions.confirm')}
        />
      </ButtonGroup>
    </DataStatus>
  );
}
